export enum RecordStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  CANCELLED = 'CANCELLED',
}

export enum RecordType {
  INCOME = 'Income',
  EXPENSE = 'Expense',
  TRANSFER = 'Transfer',
}

export enum RecordDateFilterField {
  VALUE_DATE = 'valueDate',
  CREATED_AT = 'createdAt',
  OPERATION_DATE = 'operationDate',
}

export enum DataExportFileFormat {
  CSV = 'csv',
}

export enum BankRecordDocumentSortableFilterField {
  CREATED_AT = 'createdAt',
  DOCUMENT_DATE = 'date',
}
